import React from "react";
import Dashboard from "../Dashboard";

// Revenue keeps the existing revenue analytics UI in its own admin tab.
const Revenue = () => <Dashboard revenueOnly />;

export default Revenue;
